import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getPremiumSessionCollateral } from 'services/PremiumSessionService';
import { PremiumSessionCollateral } from 'types/premiumSession';

const useSessionCollateralData = (
  premiumSessionSlug: string,
  hasEntry = true,
  isLivePremiumSessionCourse = false,
) => {
  const [sessionCollateralData, setSessionCollateralData] =
    useState<PremiumSessionCollateral>();

  const { i18n } = useTranslation();

  const getCollateralData = useCallback(async () => {
    try {
      if (!hasEntry && isLivePremiumSessionCourse) {
        const collateral = await getPremiumSessionCollateral(
          premiumSessionSlug,
          i18n.language,
          true,
          'en-US', // fallback to english if fails
        );
        setSessionCollateralData(collateral);
      }
    } catch (error) {
      setSessionCollateralData(null);
    }
  }, [hasEntry, premiumSessionSlug, isLivePremiumSessionCourse, i18n.language]);

  useEffect(() => {
    getCollateralData();
  }, [hasEntry, premiumSessionSlug, isLivePremiumSessionCourse]);

  return { sessionCollateralData };
};

export default useSessionCollateralData;
